module.exports = __webpack_public_path__ + "media/react/marketing/sections/value_props/assets/purple/practice_tests_icon-0a68963b91382a7cc105444aac98f53a.svg";